export class VideoPlayer {
  public videoEl: HTMLVideoElement | null;
  public playBtn: HTMLButtonElement | null;
  public playing: boolean = false;

  constructor(ctx: Element) {
    this.videoEl = ctx.querySelector('video');
    this.playBtn = ctx.querySelector('.btn-play');
    this.videoEl && this.playBtn && this.init();
    this.play = this.play.bind(this);
    this.stop = this.stop.bind(this);
  }

  /* eslint-disable @typescript-eslint/no-non-null-assertion */
  private init(): void {
    this.playBtn!.addEventListener('click', () => this.play());

    this.videoEl!.addEventListener('playing', () => {
      this.playBtn?.classList.add('playing');
      this.playing = true;
      this.videoEl?.setAttribute('controls', '');
    });

    this.videoEl!.addEventListener('ended', () => this.stop());
  }

  public play(): void {
    this.videoEl!.play();
  }

  public stop(): void {
    this.videoEl!.pause();
    this.videoEl!.currentTime = 0.1;
    this.playBtn!.classList.remove('playing');
    this.playing = false;
    this.videoEl?.removeAttribute('controls');
  }
}
